import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[showTooltipWhenEllipsisActive]',
})
export class ShowTooltipWhenEllipsisActiveDirective {
    constructor(private elementRef: ElementRef) {}

    @HostListener('mouseenter')
    onMouseEnter() {
        const element = this.elementRef.nativeElement as HTMLElement;
        if (element.offsetWidth < element.scrollWidth) {
            element.title = element.textContent;
        } else if (element.title) {
            element.removeAttribute('title');
        }
    }
}
